var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iframeBox"},[_c('iframe',{attrs:{"src":"https://web.qqppk.com/","frameborder":"0","width":"100%","height":"100%"}})])
}]

export { render, staticRenderFns }